<template>
	<div class="hero-video__container" :style="style">
		<slot name="videoPlayer"></slot>

		<div class="hero-video__content">
			<slot name="content"></slot>
			<default-button
				v-if="youtubeId"
				:color="btnColor"
				:clickHandler="heroEvent"
				:label="btnModalTitle"
			></default-button>
		</div>

		<modal-video
			v-if="youtubeId"
			:modal-id="modalId"
			:video-id="youtubeId"
		></modal-video>

		<animation-killswitch
			v-if="animKillswitchIcon"
			:anim-killswitch-aria-label-turn-off="animKillswitchAriaLabelTurnOff"
			:anim-killswitch-aria-label-turn-on="animKillswitchAriaLabelTurnOn"
		>
			<template v-slot:animation>
				{{ animKillswitchLabelTurnOff }}
				<svg-icon v-if="animKillswitchIcon" :icon="animKillswitchIconTurnOff" />
			</template>

			<template v-slot:no-animation>
				{{ animKillswitchLabelTurnOn }}
				<svg-icon v-if="animKillswitchIcon" :icon="animKillswitchIconTurnOn" />
			</template>
		</animation-killswitch>
	</div>
</template>

<script>
import ModalVideo from '../ModalVideo';
import DefaultButton from '../DefaultButton';
import AnimationKillswitch from '../AnimationKillswitch';
import { EventBus } from '../../utils/EventBus';
import ResponsiveBackgroundImageMixin from '../../mixins/ResponsiveBackgroundImageMixin.js';
import SvgIcon from '../SvgIcon/SvgIcon';

export default {
	name: 'HeroVideo',
	components: {
		ModalVideo,
		DefaultButton,
		AnimationKillswitch,
		SvgIcon,
	},
	mixins: [ResponsiveBackgroundImageMixin],
	props: {
		btnModalTitle: { type: String, required: false },
		btnColor: { type: String, required: false, default: null },
		youtubeId: { type: String, required: false, default: null },
		animKillswitchAriaLabelTurnOn: { type: String, default: '' },
		animKillswitchAriaLabelTurnOff: { type: String, default: '' },
		animKillswitchLabelTurnOn: { type: String, default: '' },
		animKillswitchLabelTurnOff: { type: String, default: '' },
		animKillswitchIcon: { type: Boolean, required: false, default: false },
		animKillswitchIconTurnOn: {
			type: String,
			required: false,
			default: '',
		},
		animKillswitchIconTurnOff: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			initIframe: false,
			modalId: this.youtubeId,
		};
	},
	computed: {
		style() {
			return {
				backgroundImage: `url(${this.responsiveBackgroundImageUrl})`,
			};
		},
	},
	methods: {
		heroEvent() {
			this.initIframe = true;
			setTimeout(this.openModal, 700);
		},
		openModal: function () {
			EventBus.$emit('open-modal', this.modalId);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped></style>
